// extracted by mini-css-extract-plugin
export var dropdownIcon = "_oy-6";
export var imgContainer = "_oy-3";
export var menuIcon = "_oy-5";
export var pillWrapper = "_oy-2";
export var pillsContainer = "_oy-1";
export var subscriptionCard = "_oy-0";
export var subscriptionLogo = "_oy-4";